import { useManageSubscription } from "features/subscriptions/context/ManageSubscriptionContext";
import useRentalOrderEstimate from "features/subscriptions/hooks/useRentalOrderEstimate";
import useUpdateOrCreateEstimate from "features/subscriptions/hooks/useUpdateOrCreateEstimate";

//existing (non-cancelled) rental orders use a dedicated estimate endpoint,
//everything else goes through the generic update/create estimate
export default function useManageSubscriptionEstimate({
  couponAction,
}: {
  couponAction: string | "remove" | undefined;
}) {
  const {
    pricing,
    seatQuantity,
    initialState,
    subscriptionType,
    hasExistingSubscription,
    rentalOrderSubscription,
  } = useManageSubscription();

  const rentalOrderEstimate = useRentalOrderEstimate({
    subscription: rentalOrderSubscription,
    pricing,
    seatQuantity,
    couponAction,
    isEnabled: !!rentalOrderSubscription,
  });

  const updateOrCreateEstimate = useUpdateOrCreateEstimate({
    pricing,
    quantity: seatQuantity,
    subscriptionId: hasExistingSubscription && initialState.subscription.id,
    isCustomerSubscription: subscriptionType === "agency",
    couponAction,
    isEnabled: !rentalOrderSubscription,
  });

  return rentalOrderSubscription ? rentalOrderEstimate : updateOrCreateEstimate;
}
